import { JSX } from 'react';
import { toast, ToastOptions } from 'react-toastify';
import { Common } from '@thecvlb/design-system';

import { TAILWIND_BREAKPOINTS } from 'constants/ui';

const getSnackbarPosition = (): ToastOptions['position'] => {
  if (typeof window === 'undefined' || typeof window.matchMedia !== 'function') {
    return 'top-center';
  }
  return window.matchMedia(`(max-width: ${TAILWIND_BREAKPOINTS.md - 1}px)`).matches
    ? 'bottom-center'
    : 'top-center';
};

export const notifyError = (
  message: string,
  showAsSnackbar = false,
  customOptions?: ToastOptions
) =>
  toast.error(message, {
    closeOnClick: true,
    icon: <Common.Icon className="size-7 text-red" name="error" />,
    progressClassName: '!bg-red',
    ...(showAsSnackbar && { position: getSnackbarPosition() }),
    ...customOptions
  });

export const notifySuccess = (
  message: string | JSX.Element,
  showAsSnackbar = false,
  customOptions?: ToastOptions
) =>
  toast.success(message, {
    closeOnClick: true,
    icon: <Common.Icon className="size-7 text-secondary" name="check" />,
    progressClassName: '!bg-secondary',
    ...(showAsSnackbar && { position: getSnackbarPosition() }),
    ...customOptions
  });

// aka 'snackbar'
export const notifyToast = (
  message: string | JSX.Element,
  options?: ToastOptions,
  onBtnClick?: (...args: unknown[]) => void,
  btnText = ''
) =>
  toast.info(
    <div className="mr-4 flex w-full items-center justify-between gap-4 bg-gray-800">
      <h4 className="text-mSm text-white md:text-sm">{message}</h4>
      {!!onBtnClick && (
        <button className="min-w-fit text-secondary" onClick={onBtnClick}>
          {btnText}
        </button>
      )}
    </div>,
    {
      className: '!bg-gray-800',
      icon: false,
      position: getSnackbarPosition(),
      progressClassName: '!bg-secondary',
      theme: 'dark',
      ...options
    }
  );
